export default __webpack_public_path__ + "media/images/og-361cfe24f02abdd1c19970b8eae95cb6.png";